import { default as ReactDOM } from 'react-dom';
import App from './App';
import 'react-virtualized/styles.css';
import HttpService from '@picsart/rc/services/http';
import {
  ADYEN_KEY,
  API_URL,
  UPLOAD_URL,
  FRONTEND_VERSION,
  isDev,
  PAYPAL_KEY,
  RC_VERSION,
  REACT_APP_API_URL,
  TEMPLATE_LIST_URL,
  TRANSITIONS_URL,
  WEBSITE_URL
} from 'utils/env';
import errorLogger from './components/ErrorLogger';
import { isMobile } from 'react-device-detect';
import analytics from 'utils/analytics';
import AuthWrapper from './providers/authentication/AuthProvider';

if (isMobile) {
  window.location.href = 'https://picsart.com/create/chooser?redirect=editor';
}

// expose env vars
window.appData = {
  isDev,
  API_URL,
  UPLOAD_URL,
  WEBSITE_URL,
  TEMPLATE_LIST_URL,
  TRANSITIONS_URL,
  REACT_APP_API_URL,
  PAYPAL_KEY,
  ADYEN_KEY,
  FRONTEND_VERSION,
  RC_VERSION
};

analytics.init();

errorLogger.init();

HttpService.setConfig({
  apiUrl: API_URL
});

if (window.caches && window.caches.delete) {
  window.caches.delete('shutterstock-images');
}

ReactDOM.render(
  <AuthWrapper>
    <App />
  </AuthWrapper>,
  document.getElementById('app')
);
